import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_URL}`, // change this to your API base URL
  headers: {
    'Content-Type': 'application/json',
    // Add auth tokens here if needed
  }
});

export const api = {
  get: (url, config = {}) => apiClient.get(url, config),
  post: (url, data, config = {}) => apiClient.post(url, data, config),
  put: (url, data, config = {}) => apiClient.put(url, data, config),
  delete: (url, config = {}) => apiClient.delete(url, config),
  all: (requests) => Promise.all(requests)
};

export const formatDate = (d) =>{
    return d ? new Date(d).toISOString().slice(0, 10).split('-').reverse().join('-') : '';
}
export const curdStatus = obj => obj && obj._id 
  ? { url: `/${obj._id}`, method: 'put', msg: 'Updated' } 
  : { url: '/add', method: 'post', msg: 'Added' };
